import { parse } from 'valibot';
import type { AuthTypes } from './../types';
import useRequest from '@/shared/composables/use-request';
import { loginResponseScheme, userResponseScheme } from './schemes';

class UserSign {
	async register(payload: AuthTypes.RegisterPayload) {
		try {
			const response = await useRequest().$post('/account/register/', {
				body: payload,
			});

			if (response.status === 'error') {
				return response;
			}

			return response.data;
		} catch (error) {
			console.error(error);
		}
	}

	async verifyRegister(payload: AuthTypes.RegisterVerifyPayload) {
		try {
			const response = await useRequest().$get('/account/email-verify/', {
				query: payload,
			});

			if (response.status === 'error') {
				return response.error;
			}

			return response.data;
		} catch (error) {
			console.error(error);
		}
	}

	async login(payload: AuthTypes.LoginPayload) {
		try {
			const response = await useRequest().$post('/account/login/', {
				body: payload,
				ignoreResponseError: true,
			});

			if (response.status === 'error') {
				return response;
			}

			return parse(loginResponseScheme, response.data);
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async refresh() {
		try {
			const response = await useRequest().$post('/account/login/refresh/', {
				ignoreResponseError: true,
			});

			if (response.status === 'error') {
				return response;
			}

			return response.data;
		} catch (error) {
			console.error(error);
		}
	}

	async logout() {
		try {
			await useRequest().$post('/account/logout/', {
				ignoreResponseError: true,
			});
		} catch (error) {
			return error;
		}
	}

	async changePassword(payload: AuthTypes.ChangePasswordPayload) {
		try {
			const response = await useRequest().$post('/account/change-password/', {
				body: payload,
			});

			if (response.status === 'error') {
				return response;
			}

			return parse(userResponseScheme, response.data);
		} catch (error) {
			console.error(error);
		}
	}

	async changePasswordConfirm(payload: AuthTypes.ChangePasswordConfirmPayload) {
		try {
			const response = await useRequest().$post('/account/change-password-confirm/', {
				body: payload,
			});

			if (response.status === 'error') {
				return response;
			}

			return response.data;
		} catch (error) {
			console.error(error);
		}
	}
}

export default new UserSign();
